module.exports = __webpack_public_path__ + "static/impact_4-7d5cd487635fc9ff7a1ff808710ade56.png";